import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {map, Observable, zip} from 'rxjs';
import {InsurerService} from '../../shared/services/insurer/insurer.service';
import {TpaService} from '../../shared/services/tpa/tpa.service';
import {IndustrySegmentService} from '../../shared/services/industry-segment/industry-segment.service';
import {PolicyTypeService} from '../../shared/services/policy-type/policy-type.service';
import {CommonBlobStorageService} from '../../shared/services/blob-storage/common-blob-storage.service';
import {SpinnerOverlayService} from '../../shared/services/spinner-overlay/spinner-overlay.service';

@Injectable({
  providedIn: 'root',
})
export class QmsGuard {
  private insurerService = inject(InsurerService);
  private policyTypeService = inject(PolicyTypeService);
  private qmsBlobStorageService = inject(CommonBlobStorageService);
  private tpaService = inject(TpaService);
  private industrySegmentService = inject(IndustrySegmentService);
  private spinner = inject(SpinnerOverlayService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.spinner.performWithSpinner(zip(
      this.insurerService.loadInsurers(false),
      this.policyTypeService.loadPolicyDepartmentsAndTypes(false),
      this.qmsBlobStorageService.loadBlobStorageConfiguration(),
      this.tpaService.loadTpa(false, true),
      this.industrySegmentService.loadIndustrySegment(false)
    ).pipe(map(() => {
      return true;
    })));
  }
}
